import { useEffect, useState, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { privacyApi } from '../../lib/api';
import LoadingSpinner from '../common/LoadingSpinner';

const SKIP_PREFIXES = [
  '/privacy/acknowledge',
  '/privacy-notice',
  '/force-password-change',
  '/login',
  '/invite',
  '/candidate/interview',
  '/candidate/voice-interview',
  '/candidate/system-check',
  '/error'
];

export default function PrivacyAckGate({ children }: { children: ReactNode }) {
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [requireAck, setRequireAck] = useState(false);

  const skip = SKIP_PREFIXES.some((prefix) => location.pathname === prefix || location.pathname.startsWith(`${prefix}/`));

  useEffect(() => {
    if (skip) {
      setChecking(false);
      setRequireAck(false);
      return;
    }
    let cancelled = false;
    setChecking(true);
    privacyApi.me()
      .then((me) => {
        if (!cancelled) setRequireAck(Boolean(me.require_ack));
      })
      .catch(() => {
        if (!cancelled) setRequireAck(false);
      })
      .finally(() => {
        if (!cancelled) setChecking(false);
      });
    return () => {
      cancelled = true;
    };
  }, [location.pathname, skip]);

  if (skip) {
    return <>{children}</>;
  }

  if (checking) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (requireAck) {
    const from = `${location.pathname}${location.search}`;
    return <Navigate to={`/privacy/acknowledge?from=${encodeURIComponent(from)}`} replace />;
  }

  return <>{children}</>;
}
